<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-form
    @submit.prevent="create"
    v-model="valid"
    lazy-validation
    ref="form">
    <v-container fluid grid-list-md>
      <v-layout wrap align-center>
        <v-flex xs12 d-flex>
          <v-select
            :items="data.groups"
            :rules="[
              $rules.empty('Gruplar'),
              () => form.group_id.length > 0 || 'Gruplar alanında seçim yapmalısınız'
            ]"
            item-text="name"
            item-value="id"
            multiple
            v-model="form.group_id"
            label="Gruplar"
            required>
          </v-select>
        </v-flex>
        <v-flex md6 xs12 d-flex>
          <v-text-field
            label="Ad"
            v-model="form.name"
            required>
          </v-text-field>
        </v-flex>
        <v-flex md6 xs12 d-flex>
          <v-text-field
            label="Soyad"
            v-model="form.surname"
            required>
          </v-text-field>
        </v-flex>
        <v-flex xs12 d-flex>
          <v-text-field
            label="Telefon Numarası"
            v-model="form.phone"
            v-mask="'0(###) ### ## ##'"
            @input="form.phone = $mask.unmasked(form.phone)"
            :rules="[$rules.empty('Telefon Numarası')]"
            mask="phone"

            required>
          </v-text-field>
        </v-flex>
        <v-flex xs12 d-flex>
          <date-month-picker
            label="Doğum Tarihi"
            :required="false"
            @on:date-selected="(val) => { form.birth_day = val; }">
          </date-month-picker>
        </v-flex>
        <div v-if="settings !== null" class="layout wrap">
          <v-flex
            v-for="(custom, key) in settings"
            :key="key"
            xs6>
            <v-text-field
              :label="custom.toString()"
              :value="custom"
              v-model="form[key]"
              @input="(val) => { $set(form, key, val); }"
              outlined>
            </v-text-field>
          </v-flex>
        </div>

        <v-flex xs12 d-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="create">Kaydet</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import DateMonthPicker from '../SMSConstants/DateMonthPicker.vue';

export default {
  components: { DateMonthPicker },
  props: ['data'],
  data: () => ({
    valid: true,
    reflection: {},
    form: {
      settings: {},
      group_id: [],
    },
  }),
  async created() {
    this.reflection = await this.data.settings;
  },
  computed: {
    settings: {
      get() {
        if (this.data.settings === null) {
          return {};
        }

        return Object.filter(this.data.settings || {}, v => v !== null);
      },
      set(v) {
        this.form.settings = v;
      },
    },
  },
  methods: {
    async create() {
      if (this.$refs.form.validate()) {
        await this.$trigger('submit:contact-create', this.form);
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
